import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Handshake } from "lucide-react";

const STATUS_LABEL = { intro_made: "Intro made", meeting: "Meeting", term_sheet: "Term sheet", closed: "Closed", passed: "Passed" };
const STATUS_STYLE = {
  intro_made: "bg-sky-100 text-sky-800",
  meeting: "bg-amber-100 text-amber-800",
  term_sheet: "bg-violet-100 text-violet-800",
  closed: "bg-emerald-100 text-emerald-800",
  passed: "bg-neutral-100 text-neutral-500",
};

export const StudioIntrosCard = () => {
  const [intros, setIntros] = useState(null);

  useEffect(() => {
    let on = true;
    api.get("/founder/studio-intros")
      .then(({ data }) => on && setIntros(data.intros || []))
      .catch(() => on && setIntros([]));
    return () => { on = false; };
  }, []);

  if (!intros || intros.length === 0) return null;

  return (
    <div className="mt-6 rounded-2xl border border-neutral-200 bg-white p-4 sm:p-5" data-testid="studio-intros-card">
      <div className="flex items-center gap-2.5">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#0A8B85]/10">
          <Handshake className="h-4.5 w-4.5 text-[#0A8B85]" />
        </div>
        <div>
          <p className="text-sm font-bold text-neutral-900">Warm funder introductions</p>
          <p className="text-xs text-neutral-500">Made on your behalf by {intros[0].studio_name}</p>
        </div>
      </div>
      <div className="mt-3 divide-y divide-neutral-100">
        {intros.map((i) => (
          <div key={i.intro_id} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2.5" data-testid={`founder-intro-row-${i.intro_id}`}>
            <span className="text-sm font-semibold text-neutral-800">{i.funder_name}</span>
            <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${STATUS_STYLE[i.status] || STATUS_STYLE.intro_made}`}>
              {STATUS_LABEL[i.status] || i.status}
            </span>
            {i.created_at && <span className="ml-auto text-[11px] text-neutral-400">{i.created_at.slice(0, 10)}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
